import { useEffect, useState } from 'react'

export const APP_VERSION = (import.meta.env.VITE_APP_VERSION as string | undefined) ?? ''
export const VERSION_CHECK_MS = 10 * 60 * 1000

export async function fetchLiveVersion(): Promise<string | null> {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' })
    if (!res.ok) return null
    const body = (await res.json()) as { version?: unknown }
    return typeof body.version === 'string' ? body.version : null
  } catch {
    return null
  }
}

// True once the server has a newer frontend than this tab runs. Checked every 10 minutes and when the tab comes back.
export function useNewVersion(current: string = APP_VERSION): boolean {
  const [stale, setStale] = useState(false)
  useEffect(() => {
    if (!current || stale) return
    let live = true
    const check = async () => {
      const version = await fetchLiveVersion()
      if (live && version && version !== current) setStale(true)
    }
    const onVisible = () => { if (document.visibilityState === 'visible') void check() }
    const timer = window.setInterval(check, VERSION_CHECK_MS)
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      live = false
      window.clearInterval(timer)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [current, stale])
  return stale
}
